import apiService from "../services/apiService";

export const MANAGE_INVOICE_DOC_URL_TTL_MS = 5 * 60 * 1000;

export const extractManageInvoiceDocUrl = (response: unknown, fallbackUrl = ""): string => {
  if (typeof response === "string") {
    const text = response.trim();
    return text || fallbackUrl;
  }
  if (!response || typeof response !== "object") return fallbackUrl;
  const root = response as Record<string, unknown>;
  const data = (root.data && typeof root.data === "object" && !Array.isArray(root.data)
    ? root.data
    : root) as Record<string, unknown>;
  const url = String(
    data.url
      ?? data.s3_url
      ?? data.fileUrl
      ?? data.s3_file_key
      ?? data.file_url
      ?? data.document_url
      ?? root.url
      ?? "",
  ).trim();
  return url || fallbackUrl;
};

export const fetchManageInvoiceDocUrl = async (
  documentId: string | number,
  fallbackUrl = "",
): Promise<string> => {
  const response = await apiService.get<unknown>(
    `/disbursement/get-manage-invoice-doc/${encodeURIComponent(String(documentId))}`,
  );
  return extractManageInvoiceDocUrl(response, fallbackUrl);
};
